import React, { useState, useLayoutEffect, useRef } from "react";
import { AnimatePresence, m } from "framer-motion";

export function Ripple() {
    const [ripples, setRipples] = useState<{ x: number; y: number; size: number; key: number }[]>([]);
    const containerRef = useRef<HTMLDivElement>(null);

    useLayoutEffect(() => {
        const parent = containerRef.current?.parentElement;
        if (!parent) return;

        // Ensure parent is relative and handles overflow correctly if not already
        const computedStyle = window.getComputedStyle(parent);
        if (computedStyle.position === 'static') {
            parent.style.position = 'relative';
        }

        const handlePointerDown = (e: PointerEvent) => {
            const rect = parent.getBoundingClientRect();
            // Calculate size based on the furthest corner to ensure full coverage
            const size = Math.max(rect.width, rect.height) * 1.5;
            
            const x = e.clientX - rect.left - size / 2;
            const y = e.clientY - rect.top - size / 2;

            const newRipple = { x, y, size, key: Date.now() };
            setRipples((prev) => [...prev, newRipple]);
        };

        parent.addEventListener("pointerdown", handlePointerDown);
        return () => {
            parent.removeEventListener("pointerdown", handlePointerDown);
        };
    }, []);

    return (
        <div ref={containerRef} className="absolute inset-0 z-0 rounded-[inherit] overflow-hidden pointer-events-none" aria-hidden="true">
            <AnimatePresence>
                {ripples.map((ripple) => (
                    <m.span
                        key={ripple.key}
                        initial={{ scale: 0, opacity: 0.35 }}
                        animate={{ scale: 2, opacity: 0 }}
                        exit={{ opacity: 0 }}
                        transition={{ duration: 0.6, ease: "easeOut" }}
                        onAnimationComplete={() => {
                            setRipples((prev) => prev.filter((r) => r.key !== ripple.key));
                        }}
                        className="absolute bg-current rounded-full"
                        style={{
                            left: ripple.x,
                            top: ripple.y,
                            width: ripple.size,
                            height: ripple.size,
                        }}
                    />
                ))}
            </AnimatePresence>
        </div>
    );
}
